export {
	INCOMING_INVOICE_CHECK_GROUP_LABEL,
	INCOMING_INVOICE_CHECK_LABEL,
} from "@msuite/utils/incoming-invoices";
